import React from 'react';
import LandingNav from './LandingNav';
import Footer from './Footer';
import HeroSection from './sections/HeroSection';
import ServicesSection from './sections/ServicesSection';
import FeaturesSection from './sections/FeaturesSection';
import TestimonialsSection from './sections/TestimonialsSection';
import CTASection from './sections/CTASection';
import SectionDivider from './components/SectionDivider';
import { DappsPreview, InvestPreview } from './MarketPages';

const PremiumHome = () => {
  return (
    <div className="min-h-screen bg-deepspace overflow-hidden relative">
      {/* Navigation */}
      <LandingNav />

      {/* Background Elements */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-deepspace via-deepspace-100 to-deepspace-200"></div>
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyber-blue/10 rounded-full blur-3xl animate-pulse-slow"></div>
          <div className="absolute top-3/4 right-1/4 w-80 h-80 bg-cyber-gold/10 rounded-full blur-3xl animate-pulse-slow" style={{animationDelay: '2s'}}></div>
          <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-cyber-green/10 rounded-full blur-3xl animate-pulse-slow" style={{animationDelay: '4s'}}></div>
        </div>
      </div>

      {/* Circuit Board Pattern Overlay */}
      <div className="fixed inset-0 opacity-10 z-10">
        <img 
          src="/images/all/circuit-board-pattern-background.png" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>

      {/* Main Content */}
      <main className="relative z-20">
        {/* Hero Section */}
        <HeroSection />

        <DappsPreview />
        <InvestPreview />

        {/* Services Section */}
        <ServicesSection />

        {/* Section Divider */}
        <SectionDivider color="gold" size="medium" />

        {/* Features Section */}
        <FeaturesSection />

        {/* Section Divider */}
        <SectionDivider color="green" size="medium" />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* Section Divider */}
        <SectionDivider color="gold" size="medium" />

        {/* CTA Section */}
        <CTASection />
      </main>

      {/* Footer */}
      <div className="relative z-30">
        <Footer />
      </div>
    </div>
  );
};

export default PremiumHome;